import * as React from 'react';
import { CacheContext } from 'Workspace/Cache/Context';

export const useCacheContext = () => React.useContext(CacheContext);
